// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  URL_API: 'https://crm.poliflex.mx/crmdev/Rest.svc/',
  service: 'dev',
  APIKEY: '6e3a7c92d35c7c9b6f0020b19fba7dd99d0fc7ed3d337fc6baf9e9e1c3713cb9',
  version: 'DEVELOPMENT-16-07-2024'
};



// WEBPACK FOOTER //
// /app/src/environments/environment.ts